import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_REPORT_PLAN_CUSTOME = (body) => {
    return axiosIns.post(`/report-budget-plan-custome`, {
        responseType: "blob",
    }, {
        responseType: "arraybuffer",
        headers: {
            'Content-Type': 'application/octet-stream'
        }
    }, );
};
export const GET_REPORT = (body) => {
    return axiosIns.post(`/report-budget-plan-custome`, {
        responseType: "blob",
    }, {
        responseType: "arraybuffer",
        headers: {
            'Content-Type': 'application/octet-stream'
        }
    }, );
};

